<template>
    <ion-app>
        <default-layout />
    </ion-app>
</template>

<script lang="ts" setup>
import { IonApp } from '@ionic/vue'
import DefaultLayout from "@/layout/defaultLayout.vue"
</script>
